import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PeriodConfigServices from "./PeriodConfig.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPeriodConfig = (filter,setOpcionesT,setLoader,setFormError,setErrorPeriod,period) => async (dispatch) => {
  try {
    setLoader(true)
    const resp = await PeriodConfigServices.getPeriodConfig(filter);
    var arrayTemp = []
    resp.data.data.filter((e)=>e.periodo===period).sort((a, b) => {
      if (a.nombre && b.nombre) {
        if (a.nombre === b.nombre) {
          return 0;
        }
        if (a.nombre < b.nombre) {
          return -1;
        }
      }
      return 1;
    }).map(item=>{
      let _item = item.list_tipo_evaluacion[0]
      _item.idPeriodo = item.id
      _item.fecha_inicio = item.fecha_inicio
      _item.fecha_fin = item.fecha_fin
      _item.fecha_llenado = item.fecha_llenado
      arrayTemp.push(_item)
    })
    setOpcionesT(arrayTemp.length>0?arrayTemp:[{ id: 0, nombre: "No hay evaluación" }])
    setErrorPeriod("")
    setFormError("")
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    setErrorPeriod(message)
    setFormError("")
  } finally {
    setLoader(false)
  }
};

export const getPeriodConfigById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIOD_CONFIG_BY_ID,
      payload: true,
    });
    const resp = await PeriodConfigServices.getPeriodConfigById(id);
    dispatch({
      type: actions.GET_PERIOD_CONFIG_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.PERIOD_CONFIG_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PERIOD_CONFIG_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIOD_CONFIG_BY_ID,
      payload: false,
    });
  }
};

export const savePeriodConfig = (opcionesT, setOpcionesT,setSaveLoader,setErrorPeriod,setFormError, props, dateSelected, setDateSelected) => async (dispatch, getState) => {
  try {
    setSaveLoader(true)
    var arrayTemp = [];
    opcionesT.map(async (item) => {
      let req = {
        periodicidad: props.periodicity.id,
        periodo: props.item,
        tipo_evaluacion: item.id,
      };
      if(item.id!==0){
        const _req = await PeriodConfigServices.savePeriodConfig(req);
        let _item = _req.data.list_tipo_evaluacion[0]
        _item.idPeriodo = _req.data.id
        _item.fecha_inicio = _req.data.fecha_inicio
        _item.fecha_fin = _req.data.fecha_fin
        _item.fecha_llenado = _req.data.fecha_llenado
        arrayTemp.push(_item)
        if(dateSelected.fecha_llenado!==""){
          setDateSelected(_item.fecha_llenado)
        }
      }
    });
    setOpcionesT(arrayTemp)
    setFormError("")
    setErrorPeriod("")
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    setFormError(message)
    setErrorPeriod("")
  } finally {
    setSaveLoader(false)
  }
};

export const editPeriodConfig = (opcionesT, loaderDate, setFormError, date) => async (dispatch, getState) => {
  try {
    // dispatch({
    //   type: actions.LOADING_PERIOD_CONFIG,
    //   payload: true,
    // });
    loaderDate(true)
    opcionesT.map(async (item) => {
      await PeriodConfigServices.editPeriodConfig(item.idPeriodo, {fecha_llenado: date});
    });
    setFormError("")
    toastr.success(messages.dateChanged, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_FAIL,
    //   payload: message,
    // });
    setFormError(message)
  } finally {
    // dispatch({
    //   type: actions.LOADING_PERIOD_CONFIG,
    //   payload: false,
    // });
    loaderDate(false)
  }
};

export const deletePeriodConfig = (id,setErrorPeriod,setFormError) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PERIOD_CONFIG,
      payload: true,
    });
    await PeriodConfigServices.deletePeriodConfig(id);
    setErrorPeriod("")
    setFormError("")
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    setErrorPeriod(message)
    setFormError("")
  } finally {
    dispatch({
      type: actions.LOADING_PERIOD_CONFIG,
      payload: false,
    });
  }
};
